module.exports = __webpack_public_path__ + "media/images/lb/605-5d42902cc4eb2349edc9e826cb2888be.svg";